import apiClient from './apiService';

export interface Paged<T> {
    data: T[];
    total: number;
}

interface ArchiveParams { limit?: number; offset?: number; q?: string }

const paged = (resp: any): Paged<any> => ({
    data: resp.data?.data ?? [],
    total: resp.data?.total ?? (resp.data?.data?.length ?? 0),
});

export const capaArchiveService = {
    trivialIssues: async (params?: ArchiveParams): Promise<Paged<any>> => {
        const resp = await apiClient.get('/api/v1/cap/archive/trivial-issues', { params });
        return paged(resp);
    },
    closedInvestigations: async (params?: ArchiveParams): Promise<Paged<any>> => {
        const resp = await apiClient.get('/api/v1/cap/archive/closed-investigations', { params });
        return paged(resp);
    },
    completedTasks: async (params?: ArchiveParams): Promise<Paged<any>> => {
        const resp = await apiClient.get('/api/v1/cap/archive/completed-tasks', { params });
        return paged(resp);
    },
    actionHistory: async (params?: ArchiveParams): Promise<Paged<any>> => {
        const resp = await apiClient.get('/api/v1/cap/archive/action-history', { params });
        return paged(resp);
    },
};
